import React from 'react';
import { useAuthStore } from '../store/useAuthStore';
import MyTasks from '../components/tasks/MyTasks';

const MyTasksPage = () => {
  const { user } = useAuthStore();
  
  return <MyTasks currentUser={user} />;
};

export default MyTasksPage;
